import Box from '@mui/material/Box';
import type { SxProps, Theme } from '@mui/material/styles';
import type { ReactNode } from 'react';

interface ChoiceChipProps {
  selected: boolean;
  onClick: () => void;
  children: ReactNode;
  sx?: SxProps<Theme>;
}

export const ChoiceChip = ({
  selected,
  onClick,
  children,
  sx,
}: ChoiceChipProps): JSX.Element => (
  <Box
    component="button"
    type="button"
    aria-pressed={selected}
    onClick={onClick}
    sx={[
      {
        font: 'inherit',
        fontWeight: 700,
        cursor: 'pointer',
        borderRadius: '999px',
        border: 1,
        borderColor: selected ? 'text.primary' : 'divider',
        bgcolor: selected ? 'text.primary' : 'rgb(var(--field))',
        color: selected ? 'background.paper' : 'text.secondary',
        px: 1.5,
        py: 0.75,
        transition: 'background-color 150ms ease, color 150ms ease',
        '&:hover': selected
          ? undefined
          : { color: 'text.primary', borderColor: 'text.secondary' },
        '&:focus-visible': {
          outline: '2px solid',
          outlineColor: 'primary.main',
          outlineOffset: 2,
        },
      },
      ...(Array.isArray(sx) ? sx : [sx]),
    ]}
  >
    {children}
  </Box>
);
